<template>
  <button
    :class="[
      'group cursor-pointer rounded-full bg-dustrose hover:bg-burgundy  border-transparent border transition-[border_background-color_opacity] flex items-center disabled:opacity-50',
      { 'border-burgundy!': open || dark },
    ]"
  >
    <span class="w-12.5 aspect-square flex items-center justify-center flex-col gap-1.25 relative">
      <span
        v-for="i in 3"
        :key="`hamburger-${i}`"
        :class="[
          'h-0.5 w-4.5 last-of-type:w-2.5 last-of-type:mr-2 block bg-pink transition-[rotate]',
          {
            'absolute rotate-45 even:-rotate-45 last-of-type:m-0! last-of-type:w-4.5': open,
          },
        ]"
      />
    </span>
    <span
      class="hidden lg:block uppercase mr-6 text-burgundy group-hover:text-dustrose transition-colors"
      >Menu</span
    >
  </button>
</template>

<script lang="ts">
export default {
  name: 'MenuToggle',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
